import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.lineItemsSection.LineItemsTable', {
    addLineButtonText: 'Add line',
    linesNumberReachedText: 'The limit on the number of lines has been reached.',
});
